type ELCPrice = {
    is_discounted?: boolean,
    include_tax?: {
        price?: number,
        original_price?: number,
        price_formatted?: string,
        original_price_formatted?: string
    }
}

export const parseELCPrice = (price?: ELCPrice) => {
    const tax = price?.include_tax
    return {
        price: tax?.price_formatted ?? '',
        originalPrice: tax?.original_price_formatted,
        isDiscounted: price?.is_discounted === true &&
            typeof tax?.price === 'number' &&
            typeof tax?.original_price === 'number' &&
            tax.original_price > tax.price
    }
}
